// NOVAE glass button component script.
//
// Wires up the arrow glyph's dot-to-arrow morph (three rest-state dots
// into a shaft + two head strokes) on hover/focus, using the Motion
// library's spring physics, for every .novae-glass-button on the page -
// not just a single hardcoded button, so this works no matter how many
// times snippets/novae-glass-button.liquid is rendered on a given page.
// Falls back to an instant style snap if Motion isn't loaded or the
// visitor prefers reduced motion.
//
// Self-initializes on DOMContentLoaded - pages using this component
// don't need to call anything, just load this script (see the usage
// note at the top of novae-glass-button.css).
(function () {
  function setupArrowMorph(button) {
    var lines = button.querySelectorAll('.novae-glass-button__arrow-line');
    if (lines.length !== 3) return;

    var REST = [
      { right: '12px', top: '5.5px', width: '3px', height: '3px', borderRadius: '50%', rotate: 0 },
      { right: '7px', top: '5.5px', width: '3px', height: '3px', borderRadius: '50%', rotate: 0 },
      { right: '2px', top: '5.5px', width: '3px', height: '3px', borderRadius: '50%', rotate: 0 }
    ];
    var ARROW = [
      { right: '3px', top: '6.25px', width: '14px', height: '1.5px', borderRadius: '2px', rotate: 0 },
      { right: '0px', top: '6.25px', width: '7px', height: '1.5px', borderRadius: '2px', rotate: 40 },
      { right: '0px', top: '6.25px', width: '7px', height: '1.5px', borderRadius: '2px', rotate: -40 }
    ];

    var canAnimate = !!(window.NovaeMotion && window.NovaeMotion.animate);

    function morph(targets) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var target = targets[i];

        if (reduceMotion || !canAnimate) {
          line.style.right = target.right;
          line.style.top = target.top;
          line.style.width = target.width;
          line.style.height = target.height;
          line.style.borderRadius = target.borderRadius;
          line.style.transform = 'rotate(' + target.rotate + 'deg)';
          continue;
        }

        window.NovaeMotion.animate(line, target, { type: 'spring', stiffness: 340, damping: 26, mass: 0.6 });
      }
    }

    button.addEventListener('mouseenter', function () { morph(ARROW); });
    button.addEventListener('mouseleave', function () { morph(REST); });
    button.addEventListener('focus', function () { morph(ARROW); });
    button.addEventListener('blur', function () { morph(REST); });
  }

  function setupNovaeGlassButtons(root) {
    var buttons = (root || document).querySelectorAll('.novae-glass-button');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.novaeBound) continue;
      buttons[i].dataset.novaeBound = 'true';
      setupArrowMorph(buttons[i]);
    }
  }

  // Exposed so code that swaps in new markup at runtime (e.g. the
  // coming-soon form's fetch-based submit re-rendering its button after a
  // server-side error) can re-run this for the new node(s) instead of
  // waiting on a DOMContentLoaded that already fired.
  window.NovaeGlassButton = { init: setupNovaeGlassButtons };

  document.addEventListener('DOMContentLoaded', function () {
    setupNovaeGlassButtons();
  });
})();
